import StoreService from "./store-service";

export class CacheService extends StoreService {
  DEFAULT_TTL = 3600000;
  constructor(sessionStorageCache) {
    super(sessionStorageCache);
  }

  /**
   * Cache provided value with cache expiry time
   * @param {strin} key Cache key
   * @param {Object} value Value to cache
   * @param {Number} ttl TTL in miliseconds
   */
  setWithExpiry = (key, value, ttl) => {
    const now = new Date();
    ttl = isNaN(ttl) ? this.DEFAULT_TTL : parseFloat(ttl);

    const item = {
      value: value,
      expiry: now.getTime() + ttl,
    };
    this.setItem(key, item);
  };

  /**
   * Get cached value by key
   * @param {string} key
   * @returns {Object} Cached Value if not expired, otherwise null
   */
  getWithExpiry = (key) => {
    const item = this.getItem(key);
    if (!item) {
      return null;
    }
    const now = new Date();
    if (now.getTime() > item.expiry) {
      this.removeItem(key);
      return null;
    }
    return item.value;
  };

  removeItemByKey = (key) => {
    this.removeItem(key);
  };
}
